import React from 'react';

export default function PageBreak() {
    return (
        <div className="html2pdf__page-break"></div> 
    );
}